import { Injectable } from "@angular/core";
import { CanActivate, CanLoad } from "@angular/router";
import { UserInfoModel } from "./conta/models/user-info.model";
import { LocalCookiesService } from "./conta/services/local-cookie.service";

@Injectable({ providedIn: 'root' })
export class AppGuard implements CanLoad, CanActivate {

    private usuario: UserInfoModel;
    constructor(private cookieService: LocalCookiesService) {
        this.usuario = cookieService.obterUserInfo();

    }
    canLoad(): boolean {
             
        return this.usuario?.perfil.nome==="Administrador" || this.usuario?.perfil.nome==="SuperAdministrador"
    }
    canActivate(): boolean {

        // this.usuario= this.cookieStorageService.obterUsuario();
        return this.usuario?.perfil.nome==="Administrador" || this.usuario?.perfil.nome==="SuperAdministrador"
    }
}